import React from "react";

import { THUNK_STATUS } from "@duosoftbg/nacid-components";
import { initialSERecApplicantDetails } from "./common/applicantDetailsInitialValues";
import { GradingScaleDetails, SEEducationDetails, SERecognitionApplication } from "../types/seRecognitionTypes";
import { initialDocumentDetails } from "./common/documentInitialValues";
import SERecognitionStepApplicant from "../views/components/services/secondaryEducation/form/applicant/SERecognitionStepApplicant";
import SERecognitionStepDocuments from "../views/components/services/secondaryEducation/form/documents/SERecognitionStepDocuments";
import SERecognitionStepFiling from "../views/components/services/secondaryEducation/form/filing/SERecognitionStepFiling";
import { initialCountryEmpty } from "./common/addressInitialValues";
import { ScaleTypeEnum } from "../types/common/personTypes";
import SeRecognitionStepEducation from "../views/components/services/secondaryEducation/form/education/SeRecognitionStepEducation";
import { date } from "yup";

export const initialGradingScale: GradingScaleDetails = {
  id: "",
  name: "",
  scaleType: ScaleTypeEnum.NUMERIC,
  description: "",
  country: initialCountryEmpty,
};

export const initialAdditionalSubjects = {
  additionalStudiedSubjectsNote: "",
  additionalStudiedSubjects: [],
};

export const initialStudiedSubjects = {
  key: 10,
  subjectName: "",
  translatedSubjectName: "",
  diplomaGrade: "",
};

export const initialSeRecognitionEducation: SEEducationDetails = {
  hasCertificate: true,
  hasOfficialNote: false,
  hasVerificationLetter: false,
  schoolName: "",
  schoolSettlement: "",
  schoolCountry: initialCountryEmpty,
  diplomaNumber: "",
  diplomaYear: "",
  diplomaDate: "",
  diplomaRegisterURL: "",
  diplomaApostilleURL: "",
  studiedSubjects: [initialStudiedSubjects],
  additionalSubjects: initialAdditionalSubjects,
  recognitionPurposes: [],
  recognitionPurposeOtherDetails: "",
  gradingScale: initialGradingScale,
  additionalInfo: "",
  professionBgTitle: "",
  professionNativeTitle: "",
  prevCertNumber: "",
  note: "",
};

export const initialSeRecognitionApplication: SERecognitionApplication = {
  educationDetails: initialSeRecognitionEducation,
  dataStateStatus: THUNK_STATUS.INITIAL,
  applicantDetails: initialSERecApplicantDetails,
  documentDetails: initialDocumentDetails,
  steps: [
    {
      labelCode: "l.step.applicant",
      completed: false,
      component: <SERecognitionStepApplicant />,
      isEdited: false,
    },
    {
      labelCode: "l.step.education",
      completed: false,
      component: <SeRecognitionStepEducation />,
      isEdited: false,
    },
    {
      labelCode: "l.step.attachments",
      completed: false,
      component: <SERecognitionStepDocuments />,
      isEdited: false,
    },
    {
      labelCode: "l.step.filing",
      completed: false,
      component: <SERecognitionStepFiling />,
      isEdited: false,
    },
  ],
};
